const BASE_ENDPOINT = '/beneficiary-service/resources';

function mountEndpoint(endpoint: string, prefix: string = BASE_ENDPOINT): string {
  return `${prefix}${endpoint}`;
}

const POST = {
  ADITIVO_CONTRATUAL_RECUSAR: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/recusa'),
  ALTERAR_SENHA: mountEndpoint('/beneficiario/:nrSeqBeneficiario/alterar-senha'),
  BOLETOS_POR_EMAIL: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/boletos/salvar'),
  CARTAO_CONFIRMAR: mountEndpoint('/cartao/:nrSeqBeneficiario/confirmar'),
  CARTAO_SOLICITAR: mountEndpoint('/cartao/:nrSeqBeneficiario/solicitar'),
  CONFIRMACAO_NOVO_USUARIO: mountEndpoint('/confirmar-usuario/:hash'),
  NOVA_SENHA: mountEndpoint('/recuperar-senha/:hash'),
  NOVO_USUARIO: mountEndpoint('/novo-usuario'),
  NOTIFICACAO_ATUALIZAR_CADASTRO: mountEndpoint('/notificacoes/notificacao-atualizar-cadastro'),
  RECUPERAR_SENHA: mountEndpoint('/recuperar-senha'),
  REFRESH: mountEndpoint('/authentication'),
  RELATORIO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/grupos-relatorios/:cdGrupo/relatorios/gerar'),
  RENOVAR_SENHA: mountEndpoint('/renovar-senha'),
  REVOKE: mountEndpoint('/logout'),
  SOLIC_ALT_CADASTRO: mountEndpoint('/pessoas/:cdPessoaFisica/solicitacao-alteracao-cadastral'),
  SOLICITAR_CANCELAMENTO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/cancelamento/confirmar'),
  SOLICITAR_PARTICIPACAO: mountEndpoint('/medicina-preventiva/solicitar'),
  UPLOAD_FILE: mountEndpoint('/temp/upload'),
  AUDIT_FUNCTION: mountEndpoint('/audit/function'),
  CONFIRMAR_LEITURA_TODAS_NOTIFICACOES: mountEndpoint('/notificacoes/confirmar-todas-leituras'),
  CONFIRMAR_LEITURA_NOTIFICACAO: mountEndpoint('/notificacoes/confirmar-leitura'),
  CONFIRMAR_LEITURA_MENSAGEM: ('/beneficiary-service/resources/mensagens/:nrSeqBeneficiario/gerar-leitura'),
  NOVO_CHAMADO: mountEndpoint('/beneficiary/:nrSeqBeneficiario/new-call'),
  TERMS: mountEndpoint('/terms'),
  CHECK_ADITIVO_CONTRATUAL: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/check'),
  RECUSAR_ADITIVO_CONTRATUAL: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/recusa'),
};

const GET = {
  ADITIVO_CONTRATUAL: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/details/:nrSeqTermo'),
  AVISO_PRIVACIDADE: mountEndpoint('/aviso-de-privacidade'),
  CARTAO_STATUS: mountEndpoint('/cartao/:nrSeqBeneficiario/status'),
  CHECK_GUIA_TISS: mountEndpoint('/autorizacoes/:nrSeqBeneficiario/autorizacao/:nrSeqGuia/possui-tiss'),
  CONFIGURACAO: mountEndpoint('/configuracao'),
  DOWNLOAD_AUTORIZACAO: mountEndpoint('/autorizacoes/:nrSeqBeneficiario/autorizacao/:nrSeqGuia/anexos/download'),
  DOWNLOAD_REQUISICAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/requisicao-autorizacao/:nrSeqRequisicao/anexos/:nrSeqAnexo/download'),
  ENDERECO: mountEndpoint('/logradouro/endereco'),
  INFORMATION: mountEndpoint('/information'),
  MENU_DINAMICO: mountEndpoint('/dinamico/menu-option'),
  PARAMETROS_DINAMICOS: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/relatorios-dinamicos/:nrSeqRelatorio'),
  PREDEFINED_FILES: mountEndpoint('/anexos/check-tipo-anexos'),
  PREVIEW_FILE: mountEndpoint('/temp/preview?uri='),
  RELATORIOS: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/grupos-relatorios/:cdGrupo/relatorios'),
  RELATORIO_AUTORIZACAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/grupos-relatorios/:cdGrupo/relatorios-autorizacao'),
  ROL_PROCEDIMENTOS: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/informacoes-plano/rol-procedimentos'),
  STEPS_CANCELAMENTO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/cancelamento/steps'),
  TERMOS_USO: mountEndpoint('/termos-de-uso'),
  TERMO_RESCISAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/cancelamento/termo-rescisao'),
  TERMO_RESPONSABILIDADE: mountEndpoint('/termo-responsabilidade'),
  TERMO_RESPONSABILIDADE_BOLETO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/boletos/termo/:nrSeqTermo'),
  ULTIMO_ACESSO: mountEndpoint('/usuarios/info'),
  CHECK_GUIA_TISS_REQUISICAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/requisicao-autorizacao/:nrSeqRequisicao/possui-tiss'),
  CHECK_GLOSA_ITEM_REQUISICAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/requisicao-autorizacao/:nrSeqRequisicao/guia-glosas-ocorrencias/:nrSeqItem'),
  SITUACAO_CLINICA: mountEndpoint('/beneficiario/:nrSeqBeneficiario/:origem/:nrSeq/situacao-clinica'),
  GLOSAS_ITEM_PROCEDIMENTO: mountEndpoint('/autorizacoes/:nrSeqBeneficiario/autorizacao/:nrSeqGuia/procedimento/:nrSeqProc/glosas-ocorrencias'),
  GLOSAS_ITEM_MATERIAL: mountEndpoint('/autorizacoes/:nrSeqBeneficiario/autorizacao/:nrSeqGuia/material/:nrSeqMat/glosas-ocorrencias'),
  RELATORIO_REQUISICAO: mountEndpoint('/beneficiarios/:nrSeqBeneficiario/grupos-relatorios/:cdGrupo/relatorios-requisicao'),
  REPORT_BY_PATH: mountEndpoint('/report/path/:path'),
  QTDADE_NOTIFICACOES_NAO_LIDAS: mountEndpoint('/notificacoes/qtdade-notificacoes-nao-lidas'),
  QTDADE_MENSAGENS_NAO_LIDAS: mountEndpoint('/mensagens/:nrSeqBeneficiario/total-msg-nao-lidas'),
  DOWNLOAD_ANEXO_MENSAGEM: mountEndpoint('/mensagens/:nrSeqBeneficiario/download'),
  DOWNLOAD_CHAMADO_ANEXO: mountEndpoint('/beneficiary/:nrSeqBeneficiario/calls/attachments/:nrSeqAttachment/table/:nmTable/download'),
  TERMS: mountEndpoint('/terms'),
  CONTRACT_AMENDMENTS: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/lista'),
  CONTRACT_AMENDMENT: mountEndpoint('/aditivo-contratual/:nrSeqBeneficiario/termo/:nrSeqTermo'), 
};

const DELETE = {
  REMOVE_FILE: mountEndpoint('/temp/remove'),
};

const PUT = {
};

export const Endpoints: { GET: typeof GET; DELETE: typeof DELETE; POST: typeof POST, PUT: typeof PUT } = { GET, DELETE, POST, PUT };
